import React from "react";
import { Link } from "react-router-dom";

/*eslint-disable */

interface OtherPageComponentProps {
  callToAction: any;
}
const OtherPageComponent: React.FC<OtherPageComponentProps> = ({
  callToAction,
}) => {
  return (
    <div className="other-page-home-component">
      <div className="title-other-page-home-component">Más oportunidades</div>
      <div className="pages-other-page-home-component">
        {callToAction.map(
          (item: any, index: number) => (
            <div
              className="small-page-other-page-home-component"
              style={{ backgroundImage: `URL(https://manager.hyundaicolombia.co/${item.image.url})` }}
            >
              <div className="mascara-page-other-page-home-component">
                <div className="name-page-other-page-home-component">
                  {item.title}
                </div>
                <Link
                  to={item.url}
                  className="btn-page-other-page-home-component"
                >
                  Conocer
                </Link>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default OtherPageComponent;
